import { PhoneNumberPropertyRecord } from '../remote-interface/records/CalleesRecords';
import { Metrics } from '../utils/Metrics';
import { fetchSingleCalleeClient } from './calleesClient';
import { logNetworkError } from './utils/logNetworkError';
const cache = {};
const getCacheKey = ({
  objectId,
  objectTypeId
}) => `${objectId}${objectTypeId}`;
export function getValidatedNumberFromCalleeClient({
  objectId,
  objectTypeId,
  provider = ''
}) {
  const cacheKey = getCacheKey({
    objectId,
    objectTypeId
  });
  if (cache[cacheKey]) {
    return Promise.resolve(cache[cacheKey]);
  }
  return fetchSingleCalleeClient({
    objectId,
    objectTypeId
  }).then(response => {
    if (response['@result'] !== 'OK') return null;
    const phoneNumberData = response.phoneNumberProperties.find(phoneNumber => Boolean(phoneNumber.value && phoneNumber.propertyName));
    if (phoneNumberData && phoneNumberData.validatedPhoneNumber) {
      const phoneNumberRecord = new PhoneNumberPropertyRecord(phoneNumberData);
      cache[cacheKey] = phoneNumberRecord;
    }
    Metrics.counter('FETCH_SINGLE_CALLEE_CLIENT', {
      provider
    }).increment();
    return cache[cacheKey] || null;
  }).catch(networkError => {
    logNetworkError({
      networkError,
      message: 'Failed to fetch single callee client',
      extraData: {}
    });
  });
}